export const SET = '/tos/set';
